// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../../library/network/CrmNetwork.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as IncentivesRepoConfig from "./IncentivesRepoConfig.bs.js";

function fetchIncentives(msisdn, offset, country) {
  var urlParams = {};
  urlParams["campaign_type"] = "TRIP_BASED_INCENTIVE";
  urlParams["msisdn"] = msisdn;
  urlParams["offset"] = offset;
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/admin/api/v1/payout/campaign_visibility", urlParams);
  return CrmNetwork.get(requestUrl, undefined, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(IncentivesRepoConfig.IncentivesResponseConverter.execute, result);
                        });
            });
}

function fetchCampaignOrders(campaign_id, msisdn, country) {
  var urlParams = {};
  urlParams["msisdn"] = msisdn;
  urlParams["campaign_type"] = "TRIP_BASED_INCENTIVE";
  urlParams["campaign_id"] = campaign_id;
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/admin/api/v1/payout/campaign_visibility/" + campaign_id, urlParams);
  return CrmNetwork.get(requestUrl, "/admin/api/v1/payout/campaign_visibility/:campaign_id", {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(IncentivesRepoConfig.CampaignOrdersResponseConverter.execute, result);
                        });
            });
}

var IncentivesRepo = {
  fetchIncentives: fetchIncentives,
  fetchCampaignOrders: fetchCampaignOrders
};

export {
  IncentivesRepo ,
  
}
/* Config Not a pure module */
